import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { AgreementService } from "src/app/api/services";
import * as AgreementActions from "./agreement.actions";

@Injectable()
export class AgreementEffects {
	constructor(private actions$: Actions, private agreementService: AgreementService) { }

	public loadAgreement$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AgreementActions.loadAgreements),
			switchMap(({ langCode, insurerId, profileId }) =>
			this.agreementService.agreementGet({
				languageCode: langCode,
				insurerId,
				profileId
			}).pipe(
				map((agreement) =>
				AgreementActions.loadAgreementsSucess({ data: agreement?.text })
				),
				catchError((error) =>
				of(AgreementActions.loadAgreementFailure({ error }))
				)
			))
		)
	);

}
